export const FEEDBACK_TAG_LIST = [{
  id: 1,
  title: '理解有误',
  children: [
      '答非所问',
      '未理解要求',
      '未理解上下文信息'
  ]
}, {
  id: 2,
  title: '答案存在错误',
  children: [
      '存在事实错误',
      '存在逻辑问题',
      '出现重复内容',
      '格式/语法错误',
      '内容不专业',
      '系统报错'
  ]
}, {
  id: 3,
  title: '存在违法违规信息',
  children: [
      '存在违法信息',
      '存在偏见与歧视',
      '其他价值观问题'
  ]
}];

// type: Q-问题，A-答案，H-历史消息，S-停止生成，C-结束会话，T-转接会话，R-参考来源，F-点赞/点踩回执 （WH-坐席端历史消息）
export const MESSAGE_TYPE = {
  QUESTION: 'Q',
  ANSWER: 'A',
  HISTORY: 'H',
  STOP: 'S',
  CLOSE: 'C',
  TRANSFER: 'T',
  REFERENCE: 'R',
  FEEDBACK: 'F',
  WORKBENCH_HISTORY: 'WH'
};

// 应用类型；knowledge_qa-知识问答管理；summary-知识摘要；classify-知识标签提取
export const APP_TYPE = {
  QA: 'knowledge_qa',
  SUMMARY: 'summary',
  CLASSIFYS: 'classify'
};



// WEBPACK FOOTER //
// ./src/constants/chat.js